import React from "react";
import { useTranslation } from "react-i18next";
import { planzone } from "@planzone/dto";
import { usePlanzonePermissions } from "@components/permissions";

import { FilterMenu } from "@common/filterMenu";
import { FilterOptions } from "./filterOptions";
import { Props } from "./types";
import styles from "./styles.scss";

function Filters({ filter, setFilter }: Props) {
  const { t } = useTranslation();

  return (
    <div className={styles.filters}>
      <div className={styles.section}>
        <p className={styles.label}>{t("timeSheet.filters.title")}</p>
        <FilterMenu
          filter={filter}
          placeholder={t("timeSheet.filters.allResources")}
          views={["resources", "groups"]}
          openedViews={["resources"]}
          setFilter={setFilter}
        />
        <p className={styles.label}>{t("timeSheet.filters.and")} :</p>
        <FilterOptions filter={filter} onFilterChange={setFilter} />
      </div>
    </div>
  );
}

export { Filters };
